export enum RampTabAction {
  EDIT = 'EDIT_TAB',
  REMOVE = 'REMOVE_TAB',
  SELECT = 'SELECT_TAB'
}
